import { IDropdownFilterUI } from '../../utils/types';
import { ButtonGroup } from './ButtonGroup';

/**
 * Компонент выполняет функцию адаптера над ButtonGroup
 * Реализация ButtonGroup может измениться или переехать в ui-kit.
 * Компонент FilterWithButtonGroup помогает совместить общий интерфейс фильтров к интерфейсу кнопок
 * */
export interface IFilterWithButtonGroupProps<V> extends IDropdownFilterUI<V> {
  className?: string;
  testId?: string;
}

export const FilterWithButtonGroup = <V,>({ value, values, onValueChange, testId }: IFilterWithButtonGroupProps<V>) => {
  return <ButtonGroup testId={testId} currentActiveValue={value} buttons={values} onChange={onValueChange} fullWidth />;
};
